import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { MatIconModule } from '@angular/material/icon'
import { SharedService } from '@app/modules/shared/services/shared.service'
import { AuthService } from '@auth/services/auth.service'
import { environment } from '@environments/environment'
import { ZonesSheetBottomComponent } from '@venue-capacity/components/zones-sheet-bottom/zones-sheet-bottom.component'
/**
 * VCD event information component
 */
@Component({
  selector: 'ngx-event-info',
  templateUrl: './event-info.component.html',
  styleUrls: ['./event-info.component.scss'],
  imports: [CommonModule, MatIconModule]
})
export class EventInfoComponent {
  /**
   * Event model
   */
  @Input()
  event
  /**
   * Zone model
   */
  @Input()
  zone
  /**
   * List of zones
   */
  @Input()
  zones
  /**
   * Whether we are in authenticated mode
   */
  @Input()
  authenticated = false
  /**
   * Emits daily mode status
   */
  @Output()
  isShow: EventEmitter<boolean> = new EventEmitter<boolean>()
  /**
   * Emits the current selected zone
   */
  @Output()
  selectedZone: EventEmitter<any> = new EventEmitter()
  /**
   * Whether we are in single unauthenticated mode
   */
  @Input()
  singleMode = true
  /**
   * Toggles copy public VCD url component
   */
  copyItem = false
  /**
   * Successfully copied the public VCD url
   */
  isSuccess = false
  /**
   * Show daily mode
   */
  showDaily = false
  /**
   * Bottom sheet reference
   */
  sheetRef
  /**
   * Creates the component and injects it's dependencies
   * @param auth AuthService
   * @param _bottomSheet MatBottomSheet
   * @param sharedService SharedService
   */
  constructor(public auth: AuthService, private _bottomSheet: MatBottomSheet, public sharedService: SharedService) {}

  /**
   * Toggles copy link
   */
  copyLink() {
    this.copyItem = !this.copyItem
  }

  /**
   * Opens the bottom sheet with a list of available zone
   */
  openBottomSheet(): void {
    this.sheetRef = this._bottomSheet.open(ZonesSheetBottomComponent, {
      data: this
    })
  }
  /**
   * Copies the VCD public url to the clipboard
   */
  copyUrl() {
    navigator.clipboard.writeText(this.capacityDashboardUrl)
    this.isSuccess = true
    setTimeout(() => {
      this.isSuccess = false
      this.copyItem = false
    }, 2000)
  }

  /**
   * Switches to daily view
   */
  showDailyView() {
    this.showDaily = !this.showDaily
    this.isShow.emit(this.showDaily)
  }
  /**
   * Gets the VCD public url
   */
  public get capacityDashboardUrl() {
    return this.zone.slug
      ? `${environment.baseUrl}capacity/${this.auth.currentWorkspace.slug}/${this.event.slug}/${this.event.id}/${this.zone.slug}`
      : `${environment.baseUrl}capacity/${this.auth.currentWorkspace.slug}/${this.event.slug}/${this.event.id}/all_zones`
  }
}
